<template>
	<div class="phnewdetail">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>
		<div class="phnewcontcccc" v-html="detailidcons "></div>
		<hpfooter></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	export default{
		data(){
			return{
				newlists:'',
				detailid:'',
				newtyid:'',
				detailidcons:'',
			}
		},
		created() {
			window.scrollTo(0,0);
			this.pcnewlist()
			this.getParams ()
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				this.$router.push({path:'./pcnewdetail',query:{e:this.$route.query.e}})
			}
			this.ress()
		},
		components:{
			hpheader,
			hpfooter
		},
		methods:{
			getParams () {
				this.detailid = this.$route.query.e
				this.newtyid=this.$route.query.typeid
				this.pcnewlist()
				
			},
			pcnewlist(){
			  let data={
			    type_id:this.newtyid,
			    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
			    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
			    mold:'h5',
			    page:'1',
			    pageSize:this.detailid,
			  }
			  this.$api.get_new_list(data).then((res) => {
			    this.newlists=res.data
				for(let l =0;l<this.newlists.length;l++){
					if(this.newlists[l].id==this.detailid){
						this.detailidcons=this.newlists[l].content
					}
				}
			  });
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	.phnewcontcccc{
		padding: 0.88rem 0.3rem;
		font-size: 0.24rem;
	}
</style>
